
export class linearLoadBar {

	public parent: PIXI.Container;
	private loadingBarBG: PIXI.Graphics;
	private loadingBar: PIXI.Graphics;


	constructor(parent: PIXI.Container, colorIndex: number) {
		this.parent = new PIXI.Container();
		parent.addChild(this.parent);

		this.loadingBarBG = new PIXI.Graphics();

		this.loadingBarBG.beginFill(0xffffff);

		this.loadingBar = new PIXI.Graphics();
		if (colorIndex === 0) {
			this.loadingBar.beginFill(0x2bcf6d);
			this.loadingBarBG.drawRect(0, 0, 135 * 2.3, 10);
			this.loadingBarBG.endFill();
			this.loadingBarBG.x = 1920 / 2 - this.loadingBarBG.width / 2;
			this.loadingBarBG.y = 1080 / 2 + 120 + 80;
		}
		else {
			this.loadingBar.beginFill(0xff0000);
			this.loadingBarBG.drawRect(0, 0, 135 * 2, 10);
			this.loadingBarBG.endFill();
			this.loadingBarBG.x = 1920 / 2 - this.loadingBarBG.width / 2;
			this.loadingBarBG.y = 1080 / 2 + 120;
		}

		this.parent.addChild(this.loadingBarBG);

		this.loadingBar.drawRect(0, 0, 1, 10);
		this.loadingBar.endFill();
		this.loadingBar.x = this.loadingBarBG.x;
		this.loadingBar.y = this.loadingBarBG.y;
		this.parent.addChild(this.loadingBar);
		this.parent.alpha = 0;
	}

	update(percentage: number) {
		// console.log(percentage,this.loadingBarBG.width)
		this.loadingBar.width = this.loadingBarBG.width * (percentage);
	}
}
